import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Ppe } from "@/components/site/Ppe";
import { Nettoyages } from "@/components/site/Nettoyages";
import { Travaux } from "@/components/site/Travaux";
import { About } from "@/components/site/About";
import { Realisations } from "@/components/site/Realisations";
import { Avis } from "@/components/site/Avis";
import { DevisForm } from "@/components/site/DevisForm";
import { Footer } from "@/components/site/Footer";
import { ZoneIntervention } from "@/components/site/ZoneIntervention";
import { Seo } from "@/components/site/Seo";
import { ConsentBanner } from "@/components/site/Consent";
import { GA4RouteTracker } from "@/analytics/GA4RouteTracker";
import { MobileBar, MentionsLegales, Confidentialite, NotFound } from "@/components/site/Legal";
import {
  EntretienPpePage,
  NettoyageProfessionnelPage,
  NettoyageHautePressionPage,
  NettoyageFinDeBailPage,
  NettoyageFinDeChantierPage,
  TravauxEntretienPage,
  RealisationsPage,
  AProposPage,
  ContactPage,
  DebarrasPage,
} from "@/pages";

const HomePage = () => (
  <>
    <Seo
      title="Rosset Conciergerie & Services — Conciergerie et entretien d'immeubles à Sion, Valais"
      description="Conciergerie d'immeubles et PPE, nettoyage professionnel, haute pression, fin de bail et petits travaux à Sion et en Valais central. Un interlocuteur local et polyvalent. Devis gratuit : 078 638 02 03."
      path="/"
    />
    <Hero />
    <Marquee />
    <Services />
    <Manifesto />
    <Ppe />
    <Nettoyages />
    <Travaux />
    <About />
    <Realisations />
    <Avis />
    <ZoneIntervention />
    <DevisForm />
  </>
);

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="font-body bg-white text-encre">
      <BrowserRouter>
        <ScrollTop />
        <GA4RouteTracker />
        <Nav />
        <main className="pb-14 md:pb-0">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/entretien-immeubles-ppe" element={<EntretienPpePage />} />
            <Route path="/nettoyage-professionnel" element={<NettoyageProfessionnelPage />} />
            <Route path="/nettoyage-haute-pression" element={<NettoyageHautePressionPage />} />
            <Route path="/nettoyage-fin-de-bail" element={<NettoyageFinDeBailPage />} />
            <Route path="/nettoyage-fin-de-chantier" element={<NettoyageFinDeChantierPage />} />
            <Route path="/travaux-entretien" element={<TravauxEntretienPage />} />
            <Route path="/debarras" element={<DebarrasPage />} />
            <Route path="/realisations" element={<RealisationsPage />} />
            <Route path="/a-propos" element={<AProposPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<Confidentialite />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <MobileBar />
        <ConsentBanner />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
